import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import { getTextError } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'
import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

const BlockSettingTextField = ({ field, value, onChange }) => {
  const { t } = useTranslation()

  const hasError = Boolean(getTextError(field, value))

  const handleChange = event => onChange(field.key, event.target.value)

  return (
    <InputWithLabel
      fullWidth
      label={t(field.label, literalTranslationOptions)}
      helperText={hasError ? t('Este campo es obligatorio') : t(field.helper, literalTranslationOptions)}
      placeholder={t(field.placeholder, literalTranslationOptions)}
      value={value}
      onChange={handleChange}
      error={hasError}
    />
  )
}

export default BlockSettingTextField
